export const eventAttendanceBadge = (status) => {
    let badge = "";
    switch (status) {
        case "waiting":
            badge = "waiting";
            break;

        case "attending":
            badge = "in-progress";
            break;

        case "attended":
            badge = "checked";
            break;

        case "did_not_attend":
            badge = "warning";
            break;

        default:
            break;
    }

    return badge;
};
